/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shrink': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g><g><g _stroke="#000"><line pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="13.5" y1="10.5" x2="23.5" y2=".5"/><line pid="1" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1=".5" y1="23.5" x2="10.5" y2="13.5"/><polyline pid="2" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="20.5,10.5 13.5,10.5 13.5,3.5"/><polyline pid="3" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="10.5,20.5 10.5,13.5 3.5,13.5"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/shrink.js